import { Button, Divider } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { useAppMeta } from "hooks";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useGetMunicipalityDetailQuery } from "store/services/LocationsApi/municipalityApi";
import { MunicipalityDetailContext } from "contexts/LocationContexts/MunicipalityDetailContext";
import MunicipalityBasicDetails from "./municipalityComponents/MunicipalityBasicDetails";
import MunicipalityDetailTabs from "./municipalityComponents/MunicipalityDetailTabs";
import { EditOutlined } from "@mui/icons-material";

const MunicipalityDetailScreen = () => {
  const { id } = useParams();
  const breadcrumbs = [
    {
      title: "Municipality",
      path: "/app/crm/municipality/list",
    },
    { title: "Municipality Detail" },
  ];
  const PageActions = () => (
    <Link to={`/app/crm/municipality/${id}/edit`} state={{ from: "detail" }}>
      <Button variant="contained" startIcon={<EditOutlined />}>
        {/* Edit */}
      </Button>
    </Link>
  );
  const {
    data: municipalityDetail,
    isLoading: loadingMunicipality,
    error,
  } = useGetMunicipalityDetailQuery(id);

  useAppMeta("Municipality Detail");

  return (
    <MunicipalityDetailContext.Provider
      value={{ municipalityDetail, loadingMunicipality }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingMunicipality}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <MunicipalityBasicDetails />
          <Divider />

          <MunicipalityDetailTabs />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </MunicipalityDetailContext.Provider>
  );
};

export default MunicipalityDetailScreen;
